// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "download-claim-file";

export const downloadClaimFileResponseSchema = z
  .object({
    signedUrl: z.string().url(),
  })
  .strict();

export const downloadClaimFileParamsSchema = z
  .object({
    claimDetailId: z.string(),
    fileName: z.string(),
  })
  .strict();




export type DownloadClaimFileResponse = z.infer<
  typeof downloadClaimFileResponseSchema
>;

export type DownloadClaimFileParams = z.infer<
  typeof downloadClaimFileParamsSchema
>;




// receiver/download-claim-file endpoint
export function downloadClaimFile(
  params: z.input<typeof downloadClaimFileParamsSchema>
): Promise<DownloadClaimFileResponse> {
  return requestHandler(
    "receiver/download-claim-file",
    params,
    downloadClaimFileResponseSchema,
  );
}

